(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amz-deals"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('.amz-scroller').forEach(function(s){
      if(s.dataset.amzInit) return; s.dataset.amzInit=1;
      var t=s.querySelector('[data-amz-track]'),p=s.querySelector('[data-amz-prev]'),n=s.querySelector('[data-amz-next]');
      if(!t) return;
      function upd(){ if(p) p.hidden=t.scrollLeft<4; if(n) n.hidden=t.scrollLeft+t.clientWidth>=t.scrollWidth-4; }
      if(p) p.addEventListener('click',function(){t.scrollBy({left:-t.clientWidth*0.9,behavior:'smooth'})});
      if(n) n.addEventListener('click',function(){t.scrollBy({left:t.clientWidth*0.9,behavior:'smooth'})});
      t.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amz-nav"]) return;
  try {
    
(function(){
  function q(s,r){return (r||document).querySelector(s)}
  function openDept(){var d=q('#amz-dept');if(!d)return;d.hidden=false;document.documentElement.classList.add('amz-lock');document.querySelectorAll('[data-amz-dept-open]').forEach(function(b){b.setAttribute('aria-expanded','true')});var x=q('.amz-dept__x',d);x&&x.focus();}
  function closeDept(){var d=q('#amz-dept');if(!d)return;d.hidden=true;document.documentElement.classList.remove('amz-lock');document.querySelectorAll('[data-amz-dept-open]').forEach(function(b){b.setAttribute('aria-expanded','false')});}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-amz-dept-open]')){e.preventDefault();openDept();return;}
    if(e.target.closest('[data-amz-dept-close]')){e.preventDefault();closeDept();return;}
    if(e.target.closest('[data-amz-search-focus]')){e.preventDefault();var i=q('[data-amz-search-input]');if(i){window.scrollTo({top:0,behavior:'smooth'});setTimeout(function(){i.focus()},250);}}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDept()});
  function setCount(n){document.querySelectorAll('[data-amz-cart-count]').forEach(function(b){b.textContent=n;b.hidden=!n})}
  function refreshCart(){fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js').then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){})}
  ['cart:update','cart:updated','cart:change','cart-update'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(refreshCart,300)})});
  window.addEventListener('pageshow',refreshCart);
  function sticky(){
    var nav=q('.amz-nav[data-amz-sticky]');if(!nav)return;var bar=nav.parentElement&&nav.parentElement.classList.contains('shopify-section')?nav.parentElement:nav;
    var hdr=q('#header-group');
    function upd(){var t=0;if(hdr){var r=(q('#header-component')||hdr).getBoundingClientRect();if(r.bottom>0&&r.top<=1)t=Math.round(r.bottom);}bar.style.top=t+'px';}
    window.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
  }
  function compact(){
    var nav=q('.amz-nav'),dock=q('.amz-tabs'),last=window.scrollY,tick=false;
    window.addEventListener('scroll',function(){ if(tick)return; tick=true; requestAnimationFrame(function(){
      var y=window.scrollY,down=y>last+4,up=y<last-4;
      if(nav){ if(down&&y>140) nav.classList.add('is-compact'); else if(up||y<60) nav.classList.remove('is-compact'); }
      if(dock){ if(down&&y>200) dock.classList.add('is-hidden'); else if(up) dock.classList.remove('is-hidden'); }
      if(down||up) last=y; tick=false; }); },{passive:true});
  }
  function boot(){['#amz-dept','.amz-tabs'].forEach(function(sel){var el=q(sel);if(el&&el.parentElement!==document.body)document.body.appendChild(el)});sticky();compact();refreshCart();}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amz-top"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initScrollers(root){
    root.querySelectorAll('.amz-scroller').forEach(function(s){
      if(s.dataset.amzInit) return; s.dataset.amzInit=1;
      var t=s.querySelector('[data-amz-track]'),p=s.querySelector('[data-amz-prev]'),n=s.querySelector('[data-amz-next]');
      if(!t) return;
      function upd(){ if(p) p.hidden=t.scrollLeft<4; if(n) n.hidden=t.scrollLeft+t.clientWidth>=t.scrollWidth-4; }
      if(p) p.addEventListener('click',function(){t.scrollBy({left:-t.clientWidth*0.9,behavior:'smooth'})});
      if(n) n.addEventListener('click',function(){t.scrollBy({left:t.clientWidth*0.9,behavior:'smooth'})});
      t.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
    });
  }
  function initHero(root){
    root.querySelectorAll('[data-amz-hero]').forEach(function(h){
      if(h.dataset.amzInit) return; h.dataset.amzInit=1;
      var t=h.querySelector('.amz-hero__track'),dots=h.querySelectorAll('.amz-hero__dots span'),n=t.children.length;
      function cur(){return Math.round(t.scrollLeft/t.clientWidth)}
      function paint(){dots.forEach(function(d,i){d.classList.toggle('is-on',i===cur())})}
      t.addEventListener('scroll',paint,{passive:true}); paint();
      if(n>1) setInterval(function(){ if(document.hidden) return; var i=(cur()+1)%n; t.scrollTo({left:i*t.clientWidth,behavior:'smooth'}); },5000);
    });
  }
  function stickySearch(){
    var bar=document.querySelector('[data-amz-sticky]'); if(!bar) return;
    var hdr=document.querySelector('#header-group, .header-section, [id*="header_section"]');
    function upd(){
      var top=0;
      if(hdr){ var cs=getComputedStyle(hdr); var r=hdr.getBoundingClientRect(); if(r.bottom>0 && (cs.position==='sticky'||cs.position==='fixed'||r.top<=0)) top=Math.max(0,Math.round(r.bottom)); }
      bar.style.top=top+'px';
    }
    window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
  }
  function all(){initScrollers(document);initHero(document);stickySearch();}
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
